"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _json2formData = _interopRequireDefault(require("./functions/json2formData"));

var _parseObjectToUrlParams = _interopRequireDefault(require("./functions/parseObjectToUrlParams"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var events = {};
/**
 * http 方法
 * @param {string} url - 请求地址
 * @param {object} options - 请求参数
 * @param {string} options.method - 方法类型 
 * @param {json} options.body - 请求内容
 * @param {object} options.headers - 请求头
 * @return {Promise} Http 返回结果.
 * @memberof http
 */

function http(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var original = options.original,
      params = options.params;
  if (params) url += '?' + (0, _parseObjectToUrlParams["default"])(params);
  return (0, _isomorphicFetch["default"])(url, options).then(function (response) {
    if (original) return response; // HTTP请求异常

    if (response.status !== 200) {
      http.trigger(response.status, response); // throw response;
    } // 业务数据正常返回


    return response.json().then(function (res) {
      // 业务逻辑
      if (res.code !== "0") {
        http.trigger(res.code, response);
        throw res;
      }

      return res.result;
    }, function (err) {
      http.trigger('DATA-ERROR', response);
      throw err;
    });
  }, function (err) {
    http.trigger('FETCH-ERROR', err);
    throw err;
  });
}

http.defaults = {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
};
/**
 * http.get 方法
 * @function http.get
 * @param {string} url - 请求地址
 * @param {object} options - 请求参数
 * @param {object} options.headers - 请求头
 * @return {Promise} Http 返回结果.
 * @memberof http
 */

http.get = function (url, options) {
  options = options || {};
  options.method = "GET";
  options = (0, _merge["default"])({}, http.defaults, options);
  return http(url, options);
};
/**
 * http.post 方法
 * @function http.post
 * @param {string} url - 请求地址
 * @param {object} data - 请求内容
 * @param {object} options - 请求参数
 * @param {object} options.headers - 请求头
 * @return {Promise} Http 返回结果.
 * @memberof http
 */


http.post = function (url, data, options) {
  options = options || {};
  options.body = JSON.stringify(data);
  options.method = "POST";
  options = (0, _merge["default"])({}, http.defaults, options);
  return http(url, options);
};

http.put = function (url, data, options) {
  options = options || {};
  options.body = JSON.stringify(data);
  options.method = "PUT";
  options = (0, _merge["default"])({}, http.defaults, options);
  return http(url, options);
};

http.patch = function (url, data, options) {
  options = options || {};
  options.body = JSON.stringify(data);
  options.method = "PATCH";
  options = (0, _merge["default"])({}, http.defaults, options);
  return http(url, options);
};

http["delete"] = function (url, options) {
  options = options || {};
  options.method = "DELETE";
  options = (0, _merge["default"])({}, http.defaults, options);
  return http(url, options);
};

http.on = function (name, handler) {
  if (!events[name]) events[name] = [];
  events[name].push(handler);
};

http.trigger = function (name, data) {
  var handlers = events[name];

  if (handlers) {
    handlers.forEach(function (handler) {
      return handler(data);
    });
  }
}; // 特殊请求


http.postForm = function (url, data, options) {
  options = options || {};
  options.body = (0, _json2formData["default"])(data);
  options.headers = options.headers ? _objectSpread(_objectSpread({}, options.headers), {}, {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }) : {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  };
  options.method = "POST";
  options = (0, _merge["default"])({}, http.defaults, options);
  return http(url, options);
};
/**
 * @namespace http
 */


var _default = http;
exports["default"] = _default;
module.exports = exports.default;